<!-- MFITTでクレジットカード未登録状態で購入に進もうとした場合 -->
<template>
  <ItemDialog ref="notRegisteredCreditCard" imageType="alert">
    <template v-slot:content-area>
      <h2>購入エラー</h2>
      <p class="text-center">
        有効なクレジットカードが登録されていないため、購入ができません。<span v-if="errorCode">(エラーコード:{{errorCode}})</span><br />
予約のみ行いますか？
      </p>
    </template>
    <template v-slot:button-area>
      <ItemButton
        label="予約のみ行う"
        actionType="btn-primary"
        @clicked="goToNextPage()"
      />
      <ItemButton label="閉じる" actionType="btn" @clicked="closeDialog()" />
    </template>
  </ItemDialog>
</template>

<script>
import { onMounted, ref, SetupContext } from "vue";
import { useStore } from "vuex";

export default {
  name: "DialogNotRegisteredCreditCard",
  setup(props, context) {
    const store = useStore();

    const errorCode = ref(null);

    const goToNextPage = () => {
      context.emit("goToNextPage");
    };

    const notRegisteredCreditCard = ref(null);
    const openDialog = () => {
      const creditCard = store.getters["common/CreditCard"];
      console.log('creditCard.card_status :>> ', creditCard.card_status);
      // クレカ登録がないもしくは有効でない場合
      switch (creditCard.card_status) {
        case "suspended":
          errorCode.value = "S"
          break;
        case "unknown":
          errorCode.value = "U"
          break;          
        default:
          break;
      }

      notRegisteredCreditCard.value.open();
    };

    const closeDialog = () => {
      notRegisteredCreditCard.value.close();
    };

    return {
      notRegisteredCreditCard,
      goToNextPage,
      openDialog,
      closeDialog,
      errorCode
    };
  },
};
</script>
